import { useReduxDialogControls } from '../common/utils/dialogUtils';
import { SimpleConfirmDialog } from '../components/dialogs/SimpleConfirmDialog';
import { useVersionIncompatibilityDialogStyles } from './VersionIncompatibilityDialog.styles';

export default function VersionIncompatibilityDialog() {
  const { styles } = useVersionIncompatibilityDialogStyles();
  const { isOpen } = useReduxDialogControls({
    id: 'app.incompatbileVersion',
  });

  return (
    <SimpleConfirmDialog
      className={styles.dialog}
      open={isOpen}
      onOk={() => window.location.reload()}
      textId="dialogs.versionIncompatibility.text"
      okTextId="dialogs.versionIncompatibility.refresh"
      mask
    />
  );
}
